"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8 0-1.12.23-2.18.65-3.15.09.09.21.15.35.15.28 0 .5-.22.5-.5 0-.25-.19-.45-.43-.49.15-.26.32-.51.49-.75-.03.08-.06.15-.06.24 0 .28.22.5.5.5s.5-.22.5-.5S6.28 7 6 7c-.13 0-.25.05-.34.13.52-.68 1.15-1.28 1.86-1.76-.01.04-.02.08-.02.13 0 .28.22.5.5.5s.5-.22.5-.5c0-.24-.17-.43-.4-.48.16-.09.32-.17.49-.25.09.14.24.23.41.23.28 0 .5-.22.5-.5 0-.03-.01-.06-.02-.09.39-.13.79-.23 1.21-.3-.11.1-.19.23-.19.39 0 .28.22.5.5.5s.5-.22.5-.5c0-.21-.13-.38-.3-.46.26-.03.53-.04.8-.04s.54.01.8.04c-.18.08-.3.25-.3.46 0 .28.22.5.5.5s.5-.22.5-.5c0-.16-.08-.29-.19-.38.41.07.82.17 1.21.3-.01.02-.02.05-.02.08 0 .28.22.5.5.5.17 0 .32-.09.41-.23.17.08.33.16.49.25-.23.05-.4.24-.4.48 0 .28.22.5.5.5s.5-.22.5-.5c0-.05-.01-.09-.03-.13.71.48 1.34 1.08 1.86 1.76-.08-.08-.2-.13-.33-.13-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5c0-.09-.03-.16-.07-.23.18.24.34.49.49.75-.23.03-.42.23-.42.48 0 .28.22.5.5.5.14 0 .26-.06.35-.15.42.97.65 2.03.65 3.15 0 4.41-3.59 8-8 8"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "9",
  cy: "13",
  r: "1.25"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "12",
  cy: "5.5",
  r: ".5"
}, "2"), /*#__PURE__*/_jsx("circle", {
  cx: "14",
  cy: "5.5",
  r: ".5"
}, "3"), /*#__PURE__*/_jsx("circle", {
  cx: "10",
  cy: "5.5",
  r: ".5"
}, "4"), /*#__PURE__*/_jsx("circle", {
  cx: "17",
  cy: "6.5",
  r: ".5"
}, "5"), /*#__PURE__*/_jsx("circle", {
  cx: "9",
  cy: "6.5",
  r: ".5"
}, "6"), /*#__PURE__*/_jsx("circle", {
  cx: "7",
  cy: "6.5",
  r: ".5"
}, "7"), /*#__PURE__*/_jsx("circle", {
  cx: "11",
  cy: "6.5",
  r: ".5"
}, "8"), /*#__PURE__*/_jsx("circle", {
  cx: "13",
  cy: "6.5",
  r: ".5"
}, "9"), /*#__PURE__*/_jsx("circle", {
  cx: "15",
  cy: "6.5",
  r: ".5"
}, "10"), /*#__PURE__*/_jsx("circle", {
  cx: "12",
  cy: "7.5",
  r: ".5"
}, "11"), /*#__PURE__*/_jsx("circle", {
  cx: "14",
  cy: "7.5",
  r: ".5"
}, "12"), /*#__PURE__*/_jsx("circle", {
  cx: "16",
  cy: "7.5",
  r: ".5"
}, "13"), /*#__PURE__*/_jsx("circle", {
  cx: "10",
  cy: "7.5",
  r: ".5"
}, "14"), /*#__PURE__*/_jsx("circle", {
  cx: "8",
  cy: "7.5",
  r: ".5"
}, "15"), /*#__PURE__*/_jsx("circle", {
  cx: "9",
  cy: "8.5",
  r: ".5"
}, "16"), /*#__PURE__*/_jsx("circle", {
  cx: "7",
  cy: "8.5",
  r: ".5"
}, "17"), /*#__PURE__*/_jsx("circle", {
  cx: "11",
  cy: "8.5",
  r: ".5"
}, "18"), /*#__PURE__*/_jsx("circle", {
  cx: "13",
  cy: "8.5",
  r: ".5"
}, "19"), /*#__PURE__*/_jsx("circle", {
  cx: "15",
  cy: "8.5",
  r: ".5"
}, "20"), /*#__PURE__*/_jsx("circle", {
  cx: "17",
  cy: "8.5",
  r: ".5"
}, "21"), /*#__PURE__*/_jsx("circle", {
  cx: "15",
  cy: "13",
  r: "1.25"
}, "22")], 'Face5Outlined');